import { all, fork } from "redux-saga/effects"

//public
import AccountSaga from "./auth/register/saga"
import AuthSaga from "./auth/login/saga"
import ForgetSaga from "./auth/forgetpwd/saga"
import ProfileSaga from "./auth/profile/saga"
import LayoutSaga from "./layout/saga"
import mailsSaga from "./mails/saga"
import dashboardSaga, { BarChartSaga, CountsSaga, PieChartSaga, RecentQuotesSaga, } from "./dashboard/saga";
import dashboardSaasSaga from "./dashboard-saas/saga";
import clientList from "./clients/getclients/saga";
import newClientSaga from "./clients/addclient/saga";
// import getClientIdSaga from "./clients/getbyid/saga";'

import AdminSaga, { RoleAdminSaga } from './admin/getAdmin/saga'
import AddAdminSaga from './admin/addAdmin/saga'
import GetAdminByIdSaga from './admin/getAdminById/saga'
import StatusSaga from "./admin/Activate--De-Activate/saga"
import UserSaga from "./user/getUser/saga"
import AddUserSaga from "./user/addUser/saga"
import GetUserByIdSaga from "./user/getUserById/saga"
import ResetPasswordSaga from './auth/resetpwd/saga'
import DeleteUserSaga, { GeneratePasswordSaga } from "./user/deleteUser/saga"
import ClientStatusSaga from "./clients/clientstatus/saga"
import BookingsSaga, { TrackBookingsSaga, GetByBookingNoSaga, GetBookingBYContainerWiseSaga } from "./booking/getBooking/saga"
import AddQuotesSeaExportGeneralCargoSaga, { AddAirShipperInfoSaga, AddSeaShipperInfoSaga, AirShipperInfoStatusUpdateSaga, DeleteQuoteSaga, GetAirShipperInfoByIdSaga, GetSeaShipperInfoByIdSaga, QuoteByIdSaga, QuotesListSaga, QuoteStatusUpdateSaga, SeaShipperInfoStatusUpdateSaga } from "./quotes/saga"
import { ForgetPasswordResendCodeSaga } from "./auth/forgetpwd/saga"
import { UpdateProfileImageSaga, UpdateProfileSaga, LoginPasswordChangeSaga } from './profile/saga'
import SettingsUpdateSaga, { GetNotificationSaga, GetSettingsSaga } from "./settings/saga"
export default function* rootSaga() {
  yield all([
    //public
    fork(AccountSaga),
    fork(AuthSaga),
    fork(ForgetSaga),
    fork(ProfileSaga),
    fork(LayoutSaga),
    fork(mailsSaga),
    fork(dashboardSaga),
    fork(dashboardSaasSaga),
    fork(clientList),
    fork(newClientSaga),
    // fork(getClientIdSaga)
    fork(AdminSaga),
    fork(AddAdminSaga),
    fork(GetAdminByIdSaga),
    fork(StatusSaga),
    fork(UserSaga),
    fork(AddUserSaga),
    fork(GetUserByIdSaga),
    fork(ResetPasswordSaga),
    fork(DeleteUserSaga),
    fork(ClientStatusSaga),
    fork(RoleAdminSaga),
    fork(BookingsSaga),
    fork(AddQuotesSeaExportGeneralCargoSaga),
    fork(QuotesListSaga),
    fork(ForgetPasswordResendCodeSaga),
    fork(QuoteByIdSaga),
    fork(GeneratePasswordSaga),
    fork(CountsSaga),
    fork(RecentQuotesSaga),
    fork(PieChartSaga),
    fork(BarChartSaga),
    fork(UpdateProfileSaga),
    fork(LoginPasswordChangeSaga),
    fork(DeleteQuoteSaga),
    fork(TrackBookingsSaga),
    fork(UpdateProfileImageSaga),
    fork(QuoteStatusUpdateSaga),
    fork(GetByBookingNoSaga),
    fork(GetBookingBYContainerWiseSaga),
    fork(SettingsUpdateSaga),
    fork(GetSettingsSaga),
    fork(AddAirShipperInfoSaga),
    fork(GetAirShipperInfoByIdSaga),
    fork(AddSeaShipperInfoSaga),
    fork(GetSeaShipperInfoByIdSaga),
    fork(AirShipperInfoStatusUpdateSaga),
    fork(SeaShipperInfoStatusUpdateSaga),
    fork(GetNotificationSaga)
  ])
}